import { useState } from "react";
import { PageMeta } from "@/components/common/PageMeta";
import { SubscribeForm } from "@/components/common/SubscribeForm";
import { ScrollSection } from "@/components/main-page/ScrollSection";
import { InsightsHero } from "@/components/insights/InsightsHero";
import { ArticleCard } from "@/components/insights/ArticleCard";
import { useArticles } from "@/lib/insights";
import { cn } from "@/lib/cn";

const CATEGORIES = ["All", "Product", "Company", "Announcement", "Engineering"];

export function InsightsPage() {
  const [activeCategory, setActiveCategory] = useState("All");
  const all = useArticles();
  const articles = activeCategory === "All" ? all : all.filter((a) => a.category === activeCategory);

  return (
    <>
      <PageMeta
        title="Insights | COSX"
        description="Thinking, updates, and announcements from the COSX team. AI agents for regulated industries."
        path="/insights"
      />

      <InsightsHero />

      <ScrollSection id="articles" title="Articles" compact>
        {/* Category pills */}
        <div className="flex flex-wrap gap-2 mb-10">
          {CATEGORIES.map((cat) => (
            <button
              key={cat}
              onClick={() => setActiveCategory(cat)}
              className={cn(
                "px-4 py-1.5 text-xs font-[family-name:var(--font-mono)] tracking-wider uppercase border transition-colors cursor-pointer",
                activeCategory === cat
                  ? "border-[var(--color-fg)] text-[var(--color-fg)]"
                  : "border-[var(--color-border)] text-[var(--color-fg-tertiary)] hover:text-[var(--color-fg-secondary)] hover:border-[var(--color-fg-secondary)]",
              )}
            >
              {cat}
            </button>
          ))}
        </div>

        {articles.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {articles.map((article) => (
              <ArticleCard key={article.slug} article={article} />
            ))}
          </div>
        ) : (
          <p className="text-sm text-[var(--color-fg-tertiary)] font-[family-name:var(--font-mono)] py-12">
            No articles in this category yet.
          </p>
        )}
      </ScrollSection>

      {/* Subscribe section */}
      <ScrollSection id="subscribe" title="Stay in the loop" subtitle="Get notified when we publish new insights. No spam, unsubscribe anytime." compact>
        <SubscribeForm />
      </ScrollSection>
    </>
  );
}
